/* eslint-disable react/no-unknown-property */

import classNames from 'classnames';
import Image from 'next/image';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { selectors, actions } from '@/domains/mini-market';

import styles from './index.module.scss';

export const DeviceImages = ({ images }) => {
  const dispatch = useDispatch();
  const { selectedImage } = useSelector(selectors.selectMiniMarket);
  useEffect(() => {
    dispatch(actions.setSelectedImage(images?.[0]));
  }, []);
  const handleClick = (image) => {
    dispatch(actions.setSelectedImage(image));
  };
  return images.map((image) => {
    return (
      <div
        dataImageId={image}
        onClick={() => handleClick(image)}
        key={image}
        className={classNames(styles.singleImage, {
          [styles.singleImage__active]: selectedImage === image,
        })}
        itemScope
        itemType='https://schema.org/ImageObject'
      >
        <Image
          objectFit='contain'
          alt='device small image'
          title='Device Small Image'
          src={image}
          width={64}
          height={64}
        />
      </div>
    );
  });
};
